import { useState, useEffect, useRef } from 'react';
import { optimiserTousMurs } from '../utils/optimisation';
import { calculerOssature } from '../utils/railOptimisation';

const useOptimisation = (murs, plaqueDimensions) => {
    // État pour le résultat de l'optimisation
    const [resultat, setResultat] = useState(null);

    // État pour la réutilisation des chutes
    const [utiliserChutes, setUtiliserChutes] = useState(true);

    // Le résultat affiché devient obsolète dès qu'une donnée d'entrée change
    // (dimensions de mur/plaque, ouvertures, option chutes). On l'efface pour
    // éviter d'afficher des plaques calculées sur d'anciennes dimensions.
    const premierRendu = useRef(true);
    useEffect(() => {
        if (premierRendu.current) {
            premierRendu.current = false;
            return;
        }
        setResultat(null);
    }, [murs, plaqueDimensions, utiliserChutes]);

    // Fonction pour calculer l'optimisation
    const optimiserDecoupes = (erreurs = {}) => {
        // Vérifier s'il y a des erreurs
        if (Object.keys(erreurs).length > 0) {
            alert("Veuillez corriger les erreurs avant de calculer l'optimisation");
            return;
        }
        // Utiliser l'algorithme réel d'optimisation avec le paramètre utiliserChutes
        const resultatOptimisation = optimiserTousMurs(murs, plaqueDimensions, utiliserChutes);

        // Calculer l'ossature pour chaque mur
        if (resultatOptimisation && resultatOptimisation.murDetails) {
            resultatOptimisation.murDetails.forEach(detail => {
                const mur = murs.find(m => m.id === detail.murId);
                if (mur) {
                    detail.ossature = calculerOssature(mur);
                }
            });
        }

        setResultat(resultatOptimisation);
    };

    return {
        state: {
            resultat,
            utiliserChutes
        },
        actions: {
            setResultat,
            setUtiliserChutes,
            optimiserDecoupes
        }
    };
};

export default useOptimisation;
